import React, { ReactNode } from 'react'
import theme from '../../styles/theme'
import Box from '../primitives/Box'
import Row from '../primitives/Row'
import Stack from '../primitives/Stack'

type Props = {
  title: ReactNode
  text: ReactNode
  icon?: string
  href?: string
}

const DarkBlurb = ({ title, text, icon, href }: Props) => {
  const content = (
    <Box
      backgroundColor="darkBlurbBg"
      display="flex"
      flexDirection="column"
      borderRadius={24}
      color="white"
      height="100%"
      css={`
        &:hover {
          cursor: ${href ? 'pointer' : 'auto'};
          outline: 1px solid
            ${href ? theme.colors.darkBlurbHighlight : 'transparent'};

          & .DarkBlurb-arrow {
            left: 2px;
          }
        }
      `}
    >
      <Stack
        paddingY={{ xs: 24, sm: 32 }}
        paddingX={{ xs: 24, sm: 32 }}
        paddingBottom={40}
        space={{ xs: 16, lg: 24 }}
      >
        <Row
          space={{ xs: 12, lg: 8 }}
          alignItems={{ xs: 'center', md: 'flex-start', lg: 'flex-start' }}
          flexDirection={{ md: 'column', lg: 'row' }}
        >
          {icon ? (
            <Box.img width={48} height={48} loading="lazy" src={icon} />
          ) : null}

          <Row>
            <Box.h5 font="h5" lineHeight="120%" fontSize={{ xs: 18, lg: 20 }}>
              {title}
              {href && (
                // Adapted from src/components/system/Button.tsx
                <Box.span
                  className="DarkBlurb-arrow"
                  display="inline-block"
                  position="relative"
                  left={0}
                  top={2}
                  paddingLeft={12}
                  transition="all 0.15s ease-out 0s"
                >
                  &rarr;
                </Box.span>
              )}
            </Box.h5>
          </Row>
        </Row>

        <Box
          font="medium"
          maxWidth={{ xs: 'full', md: 'largeBlurb' }}
          fontSize={{ xs: 16, lg: 18 }}
        >
          {text}
        </Box>
      </Stack>
    </Box>
  )
  return !href ? (
    <Box className="links">{content}</Box>
  ) : href.startsWith('http') ? (
    <Box.a href={href}>{content}</Box.a>
  ) : (
    <Box.Link to={href}>{content}</Box.Link>
  )
}

export default DarkBlurb
